module.exports = __webpack_public_path__ + "media/country_flags/ne-302a86ea.png";